const wx = require('weixin-js-sdk');
const baseUrl = process.env.RES_HOST;

module.exports = {
  open(page, params) {
    switch (page) {
      case 'native':
        wx.miniProgram.navigateTo({
          url: params.link
        });
        break;
      case 'login':
        wx.miniProgram.navigateTo({
          url: `/subpages/login/pages/wx_login/login`
        });
        break;
      case 'family_miniprogram':
        wx.miniProgram.navigateTo({
          url: `/ciam/subpackage/pages/register/step1/step1?pageName=MEMBER_PAGE&fromChannel=SHOPPABLE_MINI_P&redirectTo=pages/h5page/h5page&pageType=page&registerChannel=SHOPPABLE_MINI_P&registerSource=OUT_STORE&registerStore=OUT_STORE&registerEnter=/subpages/login/pages/wx_login/login&enterPageType=page&storeCode=549`
        });
        break;
      case 'coupon':
        wx.miniProgram.navigateTo({
          url: `/subpages/profile/pages/coupon/coupon_list/coupon_list`
        });
        break;
      case 'offline_coupon':
        wx.miniProgram.navigateTo({
          url: `/subpages/offline/pages/offline_coupons/offline_coupons`
        });
        break
      case 'order_detail':
        break;
      case 'cms_page':
        const cms_url = `${baseUrl}/page/cms/page.html?id=${params.id}`;
        wx.miniProgram.navigateTo({
          url: `/pages/h5page/h5page?h5link=${encodeURIComponent(cms_url)}`,
        });
        break;
      case 'link':
        this._openLink(params.link);
        break;
      case 'product':
        const link = `/pages/pip/pip?artNum=${params.id}&artType=${params.type}`;
        wx.miniProgram.navigateTo({ url: link });
        break;
      case 'customer_service':
        const channel = params && params.channel ? params.channel : 'smp'
        const text = params && params.autoText ? `&autoText=${params.autoText}` : ''
        const service_url = `${baseUrl}/page/customer_service.html?channel=${channel}${text}`;
        wx.miniProgram.navigateTo({
          url: `/pages/h5page/h5page?h5link=${encodeURIComponent(service_url)}`,
        })
        break;
      case 'customer_service_tel':
        break;
      case 'assembly_service_introduction':
        // const intro_url = `${baseUrl}/page/cms/page.html?id=de5b01b91af411ea9abdb1458c865916`;
        const intro_url = `${baseUrl}/modules/cms/universal/landing-page.html?key=cn--zh--de5b01b91af411ea9abdb1458c865916`;
        wx.miniProgram.navigateTo({
          url: `/pages/h5page/h5page?h5link=${encodeURIComponent(intro_url)}`,
        });
        break;
      case 'web':
        const web_url = `${baseUrl}${params.path}`;
        wx.miniProgram.navigateTo({
          url: `/pages/h5page/h5page?h5link=${encodeURIComponent(web_url)}`,
        });
        break;
      case 'share_info':
        const share_page = `/pages/share/share?shareImageAspectRatio=${params.shareImageAspecRatio}&sharePath=${encodeURIComponent(params.sharePath)}&shareImageUrl=${encodeURIComponent(params.shareImageUrl)}&shareTitle=${params.shareTitle}`
        wx.miniProgram.navigateTo({url: share_page});
        break;
      case 'order_ikea_assembly_service':
        wx.miniProgram.navigateTo({
          url: `/subpages/profile/pages/orders/assemble?assembled=${params.assembled}&orderNumber=${params.orderNumber}`
        });
        break;
    }
  },
  // TODO move link resolve logic to server
  _openLink(link) {
    this.getFinalRoute(link.resolvedUrl)
  },

  getFinalRoute(url) {
    var h5link = '/pages/h5page/h5page?h5link='
    var route = url
    console.log(url)

    var uri = this.parseURL(url)
    console.log(uri)
    var params = uri.params

    if (uri.host === 'ikeaapp') {
      route = h5link + encodeURIComponent(url);
      switch (uri.path) {
        case '/cms/page':
          url = `${baseUrl}/page/cms/page.html?${uri.query}`
          route = h5link + encodeURIComponent(url)
          break
        case '/web':
          if (params.url) {
            url = decodeURIComponent(params.url)
          } else {
            var host = params.host ? decodeURIComponent(params.host) : baseUrl
            var path = decodeURIComponent(params.path)
            url = host + path
          }
          route = h5link + encodeURIComponent(url)
          break
        case '/scan':
          break
        case '/product':
          var id = params.id
          var type = params.type ? params.type : 'ART'
          var seriesId = params.seriesId
          route = `/pages/pip/pip?artNum=${id}&artType=${type}`
          break
        case '/ins_detail':
          var id = params.id
          route = `/pages/inspiration/inspiration?id=${id}`
          break
        case '/plp':
        case '/product_list':
          var id = params.id
          route = `/pages/plp/plp?catalogId=${id}`
          break
        case '/miniprogram':
          if (params.path) {
            if ((!params.name && !params.appId) || params.name === 'gh_f8c80781c128' || params.appId === 'wxd47892129d2fa9e9') { // 当前小程序
              route = decodeURIComponent(params.path)
            } else {
              // not support
              if (params.appId) {
                wx.miniProgram.navigateToMiniProgram({
                  appId: params.appId,
                  path: decodeURIComponent(params.path),
                  extraData: {},
                  success(res) {
                    // 打开成功
                  }
                })
                return
              }
            }
          }
          break
        case '/goSearch':
          route = `/pages/preSearch/preSearch`
          break
        case '/search':
          var query = params.query
          var displayName = params.displayName
          route = `/pages/search/search?query=${query}&displayName=${displayName}`
          if (params.id && params.type) {
            route += `&id=${params.id}&type=${params.type}`
          }else if(params.group) {
            route += `&group=${params.group}`
          }else if(params.special) {
            route += `&special=${params.special}`
          }
          break
        case '/tab_index':
          var index = params.index
          if(index == 1) {
            route = '/pages/catalog/catalog'
          }else if(index == 2) {
            route = '/pages/shopping_cart/shopping_cart'
          }else if(index == 3){
            route = '/pages/mine/mine'
          }else {
            route = '/pages/index/index'
          }
          wx.miniProgram.switchTab({
            url: route,
          });
          return;
        case '/sub_catalog':
          break
        case '/customer_service_tel':
          break
        case '/customer_service':
          const channel = params.channel ? params.channel : 'smp'
          const text = params.autoText ? `&autoText=${params.autoText}` : ''
          const service_url = `${baseUrl}/page/customer_service.html?channel=${channel}${text}`;
          route = `/pages/h5page/h5page?h5link=${encodeURIComponent(service_url)}`
        case '/assembly_service_introduction':
          break
        case '/shopping_cart':
          route = `/pages/shopping_cart_non_tab/shopping_cart_non_tab`
          break
        case '/add_multi_product_to_cart':
          route = `/pages/shopping_cart_non_tab/shopping_cart_non_tab?products=${params.products}`
          break
        case '/popCurrent':
          wx.miniProgram.navigateBack()
          return;
      }
      wx.miniProgram.navigateTo({
        url: route,
      });
    } else {
      location.href = url;
    }
  },
  parseURL(url) {
    var wholePath = url.split('//')[1] ? url.split('//')[1].split('?')[0] : ''
    var host = wholePath.split('/')[0]
    var path = wholePath.replace(host, '')
    var query = url.split('?')[1] ? url.split('?')[1] : ''
    return {
      source: url,
      protocol: url.split(':')[0],
      host: host,
      query: query,
      params: (function () {
        var params = {},
          seg = query.split('&'),
          len = seg.length,
          p;
        for (var i = 0; i < len; i++) {
          if (seg[i]) {
            p = seg[i].split('=');
            params[p[0]] = p[1];
          }
        }
        return params;
      })(),
      path: path
    };
  },
}



// WEBPACK FOOTER //
// ./src/libs/router/platform/wxminiprogram.js